<template>
  <div class="c-job-tracker">
    <div class="c-job-tracker__inner">
      <div class="c-job-tracker__search">
        <h2 class="c-job-tracker__title">{{jobTrackerTitle}}</h2>
        <label class="c-job-tracker__search-label" for="jobSearch" id="jobSearch">{{jobTrackerInputLabel}}</label>
        <JobSearchComponent
          :jobSearchTerm.sync="jobSearchTerm"
          :jobSearchPlaceholder="jobTrackerPlaceholder"
          :jobSearchButtonText="jobTrackerButtonText"
          v-on:formSearch="submitSearch"
        />
        <JobErrorComponent v-if="error" :errorMsg="errorMsg"></JobErrorComponent>
        <a :href="jobTrackerLink" class="c-job__tracker__link">{{jobTrackerLinkText}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import 'babel-polyfill'
import Vue from 'NodeModules/vue/dist/vue.min.js'
import axios from 'axios'
import endpoints from 'Globals/mando.endpoints'
import JobSearchComponent from './JobSearch.vue'
import JobErrorComponent from './JobError.vue'

export default {
  name: 'JobTracker',
  components: {
    JobSearchComponent,
    JobErrorComponent
  },
  props: {
    jobTrackerComponentId: {
      type: String
    },
    jobTrackerSiteId: {
      type: String
    },
    jobTrackerTitle: {
      type: String
    },
    jobTrackerWork: {
      type: String
    },
    jobTrackerImgUrl: {
      type: String
    },
    jobTrackerInputLabel: {
      type: String
    },
    jobTrackerPlaceholder: {
      type: String
    },
    jobTrackerButtonText: {
      type: String
    },
    jobTrackerLinkText: {
      type: String
    },
    jobTrackerLink: {
      type: String
    },
    jobTrackerNoResultsText: {
      type: String
    },
    jobTrackerServiceUnavailable: {
      type: String
    },
    jobTrackerResultsPageUrl: {
      type: String
    }
  },
  data() {
    return {
      initialLoad: true,
      result: [],
      error: false,
      errorMsg: '',
      loading: false,
      jobSearchTerm: '',
      timer: null
    }
  },
  methods: {
    submitSearch(jobSearchTerm) {
      this.jobSearchTerm = jobSearchTerm
      this.loading = true

      axios
        .get(`${endpoints('getIncidentDetails')}?id=${this.jobSearchTerm}`)
        .then(this.getSearchResultsSuccess.bind(this))
        .catch(this.getSearchResultsFail.bind(this))
        .finally(this.getSearchResultsFinally)
    },
    getSearchResultsSuccess(r) {
      if (r.status === 200) {
        if (r.data.incident) {
          this.result = r.data.incident
          window.location.href = `${this.jobTrackerResultsPageUrl}?id=${
            this.jobSearchTerm
          }`
        } else {
          this.errorMsg = this.jobTrackerNoResultsText
          this.error = true
        }
      } else {
        this.getSearchResultsFail(r)
      }
    },
    getSearchResultsFail(r) {
      this.errorMsg = this.jobTrackerServiceUnavailable
      this.error = true
    },
    getSearchResultsFinally() {
      this.timer = setTimeout(() => {
        this.initialLoad = false
        this.loading = false
        this.timer = null
      }, this.delay)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/job-tracker/JobTracker.vue